import { Tag } from "../../types/Tag";

import React from "react";
import { Card, CardContent, Typography, Chip, Grid, Box, Stack } from "@mui/material";

interface TagItemProps {
    tag: Tag;
}

const TagItem: React.FC<TagItemProps> = ({ tag }) => {
    return (
        <Grid item xs={3}>
            <Card variant="outlined">
                <CardContent>
                    <Stack direction={"column"} spacing={2}>
                        <Box>
                            <Chip label={tag.label} color="primary" />
                        </Box>
                        <Typography variant="body1">{tag.description}</Typography>
                        <Typography variant="subtitle1">{tag.count} questions</Typography>
                    </Stack>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default TagItem;
